export const MAX_LEVEL_ORDER = 4;



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/HonestWorkWrapper/constants.ts